"use client";

import { c as _c } from "react/compiler-runtime";
import { IconClipboardCheck } from "@tabler/icons-react";
import React from "react";
import { Badge } from "@components/ui/badge";
import { Button } from "@components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@components/ui/popover";
import { AssignmentNotificationsPanel, useAssignmentNotificationsController } from "@features/notifications/components/assignment-notifications-panel";
export const AssignmentNotificationsTrigger = () => {
  const $ = _c(13);
  const controller = useAssignmentNotificationsController();
  let t0;
  if ($[0] !== controller) {
    t0 = controller.t("aria.open");
    $[0] = controller;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IconClipboardCheck />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== controller.badgeCount) {
    t2 = controller.badgeCount > 0 && <Badge className="absolute -inset-e-2 -top-2 h-[18px] min-w-[18px] border-2 border-background px-1 py-0 text-[10px] leading-none">{controller.badgeCount}</Badge>;
    $[3] = controller.badgeCount;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t0 || $[6] !== t2) {
    t3 = <PopoverTrigger asChild={true}><Button variant="outline" size="icon" className="relative" aria-label={t0}>{t1}{t2}</Button></PopoverTrigger>;
    $[5] = t0;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== controller) {
    t4 = <PopoverContent align="end" className="max-h-[calc(100vh-5rem)] w-[min(calc(100vw-2rem),384px)] overflow-hidden p-0"><AssignmentNotificationsPanel {...controller} mode="popover" /></PopoverContent>;
    $[8] = controller;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <Popover>{t3}{t4}</Popover>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};